// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Slovakia from '../_raw/flag/icon_flag_slovakia.png';

export default () => <img src={Slovakia} alt="Slovakia" />;
